import { OnboardingLayout } from "Components/Layout/OnboardingLayout";
import { BusinessEntityOnboarding } from "Components/Onboarding/BusinessEntity/BusinessEntityOnboarding";
import { CenteredCircularProgress } from "Components/Shared/CenteredCircularProgress";
import { ErrorText } from "Components/Shared/Errors/ErrorText";
import { logError } from "ErrorService";
import { useCurrentUserParty } from "Hooks/useCurrentUserParty";
import { Resources, useResource } from "Translations/Resources";

export const OnboardingPage = () => {
  const { data: { type: partyType } = {}, isLoading } = useCurrentUserParty();
  const { t } = useResource();

  if (isLoading) {
    return (
      <OnboardingLayout title={t(Resources.Onboarding.LoadingTitle)}>
        <CenteredCircularProgress />
      </OnboardingLayout>
    );
  }

  if (!partyType) {
    logError(new Error("No user party type data"));
    return (
      <OnboardingLayout title={t(Resources.Onboarding.ErrorTitle)}>
        <ErrorText>{t(Resources.Error.Unexpected)}</ErrorText>
      </OnboardingLayout>
    );
  }

  return <BusinessEntityOnboarding partyType={partyType} />;
};
